import StatusBadge from '../../Ui/StatusBadge'

const HEADERS = ['Booking ID', 'Customer', 'Service', 'Vehicle', 'Scheduled At', 'Amount', 'Status']

const TD = {
  padding: '12px',
  borderBottom: '1px solid var(--border-soft)',
  verticalAlign: 'middle',
}

function formatDate(iso) {
  if (!iso) return '—'
  const d = new Date(iso)
  const now = new Date()
  const diff = Math.floor((now - d) / (1000 * 60 * 60 * 24))

  if (diff === 0) return d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })
  if (diff === 1) return 'Yesterday'
  if (diff < 7)  return `${diff} days ago`
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
}

function formatAmount(amount) {
  return `₹${parseFloat(amount).toLocaleString('en-IN')}`
}

export default function BookingsTable({ rows }) {
  if (!rows.length) {
    return (
      <p style={{ color: 'var(--text-muted)', fontFamily: "'Barlow',sans-serif", padding: '24px 0' }}>
        No bookings found.
      </p>
    )
  }

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: "'Barlow',sans-serif" }}>
        <thead>
          <tr>
            {HEADERS.map(h => (
              <th key={h} style={{
                textAlign: 'left',
                padding: '8px 12px',
                fontSize: '10px',
                color: 'var(--text-muted)',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                borderBottom: '1px solid var(--border-main)',
                whiteSpace: 'nowrap',
              }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id} className="table-row">

              {/* Booking ID */}
              <td style={TD}>
                <span style={{ color: 'var(--gold)', fontWeight: 600, fontSize: '13px' }}>
                  {r.booking_id}
                </span>
              </td>

              {/* Customer */}
              <td style={TD}>
                <span style={{ fontSize: '13px', color: 'var(--text-primary)' }}>
                  {r.customer_name}
                </span>
              </td>

              {/* Service — from service_detail */}
              <td style={TD}>
                <span style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                  {r.service_detail?.name ?? '—'}
                </span>
              </td>

              {/* Vehicle */}
              <td style={TD}>
                <span style={{ fontSize: '13px', color: 'var(--text-muted)' }}>
                  {r.vehicle}
                </span>
              </td>

              {/* Scheduled At */}
              <td style={TD}>
                <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
                  {formatDate(r.scheduled_at)}
                </span>
              </td>

              {/* Amount */}
              <td style={TD}>
                <span style={{ fontSize: '13px', color: '#4ADE80', fontWeight: 600 }}>
                  {formatAmount(r.amount)}
                </span>
              </td>

              {/* Status */}
              <td style={TD}>
                <StatusBadge status={r.status} />
              </td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
